import { abrePDF } from "../../../utils/pdf";
import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";

function ListadoDisponible() {
  const { user } = useContext(AuthContext);
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;

  const [articulos, setArticulos] = useState([]);
  const [selectedArticulo, setSelectedArticulo] = useState("");
  const [marcas, setMarcas] = useState([]);
  const [selectedMarca, setSelectedMarca] = useState("");
  // const [familias, setFamilias] = useState([]);
  // const [selectedFamilia, setSelectedFamilia] = useState("");
  const [lineas, setLineas] = useState([]);
  const [selectedLinea, setSelectedLinea] = useState("");

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [activo, setActivo] = useState("");

  const [file, setFile] = useState();
  const [photo, setPhoto] = useState();
  const [idEditArticulo, setIdEditArticulo] = useState("");
  const URL_FILEPOST = process.env.REACT_APP_URL_UPPROFILE;
  const [modalFoto, setModalFoto] = useState(false);
  const toggleFoto = () => setModalFoto(!modalFoto);
  //--- Pagination
  const [comments, setComments] = useState([]);
  // Filtro por almacén ("" = todos, como siempre)
  const [selectedAlmacen, setSelectedAlmacen] = useState("");
  // Almacén del que se surten los pedidos (lo calcula el back con las notas)
  const [almacenSurtido, setAlmacenSurtido] = useState({ id: "", nombre: "" });
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useMemo(() => {
    axios
      .get(`${URL_INVENTARIOS}Disponible`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allDisponible = response.data;
        let array = allDisponible.map((a)=>{
          if(a.inventario != 0 || a.pedido !=0 || a.disponible !=0){
          return a
          }
        }).filter(function (el) {
          return el != null;
        })
        setComments(array);

        let unicosArt = allDisponible.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.idArticulo === value.idArticulo)
        );
        setArticulos(unicosArt);

        let unicosMar = allDisponible.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.idMarca === value.idMarca)
        );
        setMarcas(unicosMar);

        // let unicosFam = allDisponible.filter(
        //   (value, index, self) =>
        //     index === self.findIndex((t) => t.idFamilia === value.idFamilia)
        // );
        // setFamilias(unicosFam);

        let unicosLinea = allDisponible.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.idLinea === value.idLinea)
        );
        setLineas(unicosLinea);
      })
      .catch((err) => {
        console.log(err);
      });


  }, []);


  useEffect(() => {
    axios
      .get(`${URL_INVENTARIOS}AlmacenSurtido`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((r) => setAlmacenSurtido({ id: r.data?.almacenSurtido || "", nombre: r.data?.nombre || "" }))
      .catch((err) => console.log("[almacén de surtido]", err));
  }, [URL_INVENTARIOS]);

  // Almacenes con existencia, del desglose que manda el back en cada artículo
  const almacenes = useMemo(() => {
    const m = {};
    comments.forEach((a) =>
      Object.entries(a.porAlmacen || {}).forEach(([id, v]) => {
        m[id] = v.nombre || id;
      })
    );
    return Object.entries(m)
      .map(([id, nombre]) => ({ id, nombre }))
      .sort((a, b) => a.nombre.localeCompare(b.nombre));
  }, [comments]);

  // Renglones según el almacén elegido. Los pedidos pendientes no tienen
  // almacén (se elige al surtir), así que lo pendiente de surtir sólo se le
  // descuenta al almacén de surtido; en los demás, su existencia completa es
  // lo disponible. "Pendiente recibir" no tiene almacén y se deja igual.
  const filasAlmacen = useMemo(() => {
    if (!selectedAlmacen) return comments;
    const esSurtido = String(selectedAlmacen) === String(almacenSurtido.id);
    return comments
      .map((a) => {
        const inv = Number(a.porAlmacen?.[selectedAlmacen]?.cantidad || 0);
        const ped = esSurtido ? Number(a.pedido || 0) : 0;
        return { ...a, inventario: inv, pedido: ped, aLaMano: inv - ped };
      })
      .filter((a) => a.inventario !== 0 || a.pedido !== 0);
  }, [comments, selectedAlmacen, almacenSurtido.id]);

  const nombreAlmacen = selectedAlmacen
    ? almacenes.find((x) => x.id === selectedAlmacen)?.nombre || ""
    : "";

  function PDFTabla() {
    let total_inventario = 0;
    let total_pedido = 0;
    let total_traspaso = 0;
    // let total_disponible = 0;
    let total_aLaMano = 0;

    const data = filasAlmacen
      .filter(
        (comment) =>
          comment.nombre.toLowerCase().includes(search.toLowerCase()) ||
          comment.marca.toLowerCase().includes(search.toLowerCase()) ||
          // comment.familia.toLowerCase().includes(search.toLowerCase()) ||
          comment.linea.toLowerCase().includes(search.toLowerCase()) ||
          comment.inventario.toString().includes(search) ||
          // comment.pedido.toString().includes(search) ||
          // comment.traspaso.toString().includes(search) ||
          // comment.disponible.toString().includes(search) ||
          comment.aLaMano.toString().includes(search)
      )
      .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
      .map((a) => {
        if (
          (selectedArticulo == 0 || selectedArticulo == a.idArticulo) &&
          (selectedLinea == 0 || selectedLinea == a.idLinea) &&
          (selectedMarca == 0 || selectedMarca == a.idMarca) 
          // &&
          // (selectedFamilia == 0 || selectedFamilia == a.idFamilia) 
        ){
          // total_inventario =
          //   parseFloat(total_inventario) + parseFloat(a.inventario);
          // total_pedido = parseFloat(total_pedido) + parseFloat(a.pedido);
          // total_traspaso = parseFloat(total_traspaso) + parseFloat(a.traspaso);
          // total_disponible =
          //   parseFloat(total_disponible) + parseFloat(a.disponible);
          // total_aLaMano =
          //   parseFloat(total_aLaMano) + parseFloat(a.aLaMano);
          return [
            a.nombre,
            new Intl.NumberFormat("en-US").format(a.inventario),
            // new Intl.NumberFormat("en-US").format(a.pedido),
            // new Intl.NumberFormat("en-US").format(a.traspaso),
            // new Intl.NumberFormat("en-US").format(a.disponible),
            new Intl.NumberFormat("en-US").format(a.aLaMano),
          ]
        }
      });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 10, 35, 18);
    doc.text(`Listado Disponible${nombreAlmacen ? ` - ${nombreAlmacen}` : ""}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Nombre",
          "Inventario",
          // "Pedido",
          // "Traspaso",
          "Disponible",
          // "A La Mano",
        ],
      ],
      body: dataPDFLimpia,
      headStyles: {
        fillColor: ["#B02307"],
        lineWidth: 0,
      },
      footStyles: {
        fillColor: ["#B02307"],
      },
      theme: "grid",
      startY: 45,
      // foot: [
      //   [
      //     "Total",
      //     new Intl.NumberFormat("en-US").format(total_inventario),
      //     new Intl.NumberFormat("en-US").format(total_pedido),
      //     new Intl.NumberFormat("en-US").format(total_traspaso),
      //     new Intl.NumberFormat("en-US").format(total_disponible),
      //     new Intl.NumberFormat("en-US").format(total_aLaMano),
      //   ],
      // ],
      showFoot: "lastPage",
    });
    abrePDF(doc, `Disponible.pdf`);
  }

  function excel() {
    const dataExcel = filasAlmacen
      .filter(
        (comment) =>
          comment.nombre.toLowerCase().includes(search.toLowerCase()) ||
          comment.marca.toLowerCase().includes(search.toLowerCase()) ||
          // comment.familia.toLowerCase().includes(search.toLowerCase()) ||
          comment.linea.toLowerCase().includes(search.toLowerCase()) ||
          comment.inventario.toString().includes(search) ||
          comment.pedido.toString().includes(search) ||
          comment.traspaso.toString().includes(search) ||
          comment.disponible.toString().includes(search) ||
          comment.aLaMano.toString().includes(search)
      )
      .map((a) => {

        if (
          (selectedArticulo == 0 || selectedArticulo == a.idArticulo) &&
          (selectedLinea == 0 || selectedLinea == a.idLinea) &&
          (selectedMarca == 0 || selectedMarca == a.idMarca) 
          // &&
          // (selectedFamilia == 0 || selectedFamilia == a.idFamilia) 
        ){
          return {
            Nombre: a.nombre,
            // Familia: a.familia,
            Linea: a.linea,
            Inventario: a.inventario,
            Pedido: a.pedido,
            Traspaso: a.traspaso,
            Disponible: a.disponible,
            "A La Mano": a.aLaMano,
          }
        }
      });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = `ListadoDisponible${nombreAlmacen ? `-${nombreAlmacen}` : ""}`;

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoDisponible",
        sheetFilter: [
          "Nombre",
          "Inventario",
          // "Familia",
          "Linea",
          "Pedido",
          "Traspaso",
          "Disponible",
          "A La Mano"
        ],
        sheetHeader: [
          "Nombre",
          "Inventario",
          // "Familia",
          "Linea",
          "Pedido",
          "Traspaso",
          "Disponible",
          "A La Mano"
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    let total_inventario = 0;
    let total_pedido = 0;
    let total_traspaso = 0;
    let total_disponible = 0;
    let total_aLaMano = 0;

    const data = filasAlmacen
      .filter(
        (comment) =>
          comment.nombre.toLowerCase().includes(search.toLowerCase()) ||
          comment.marca.toLowerCase().includes(search.toLowerCase()) ||
          // comment.familia.toLowerCase().includes(search.toLowerCase()) ||
          comment.linea.toLowerCase().includes(search.toLowerCase()) ||
          comment.inventario.toString().includes(search) ||
          comment.pedido.toString().includes(search) ||
          comment.traspaso.toString().includes(search) ||
          comment.disponible.toString().includes(search) ||
          comment.aLaMano.toString().includes(search)
      )
      .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
      .map((a) => {

        if (
          (selectedArticulo == 0 || selectedArticulo == a.idArticulo) &&
          (selectedLinea == 0 || selectedLinea == a.idLinea) &&
          (selectedMarca == 0 || selectedMarca == a.idMarca) 
          // &&
          // (selectedFamilia == 0 || selectedFamilia == a.idFamilia) 
        ){
          total_inventario = total_inventario + a.inventario;
          total_pedido = total_pedido + a.pedido;
          total_traspaso = total_traspaso + a.traspaso;
          total_disponible = total_disponible + a.disponible;
          total_aLaMano = total_aLaMano + a.aLaMano;
          return [
            a.nombre,
            new Intl.NumberFormat("en-US").format(a.inventario),
            new Intl.NumberFormat("en-US").format(a.pedido),
            new Intl.NumberFormat("en-US").format(a.traspaso),
            new Intl.NumberFormat("en-US").format(a.disponible),
            new Intl.NumberFormat("en-US").format(a.aLaMano),
          ]
        }
      });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 10, 35, 18);
    doc.text(`Listado Disponible${nombreAlmacen ? ` - ${nombreAlmacen}` : ""}`, 20, 40);
    doc.autoTable({
      head: [[ "Nombre", "Inventario", "Pedido", "Traspso", "Disponible" , "A La Mano" ]],
      body: dataPDFLimpia,
 headStyles: {
            fillColor: ["#B02307"],
            lineWidth: 0
          },
          footStyles: {
            fillColor: ["#B02307"],
          },
          theme:"grid",
      startY: 45,
      foot: [
        [
          "Total",
          new Intl.NumberFormat("en-US").format(total_inventario),
          new Intl.NumberFormat("en-US").format(total_pedido),
          new Intl.NumberFormat("en-US").format(total_traspaso),
          new Intl.NumberFormat("en-US").format(total_disponible),
          new Intl.NumberFormat("en-US").format(total_aLaMano),
        ],
      ],
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: `Listado Disponible${nombreAlmacen ? ` - ${nombreAlmacen}` : ""}`,
          email: mailTo,
          fileName: "ListadoDisponible.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Disponibles.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const headers = [
    { name: "Nombre", field: "nombre", sortable: true },
    { name: "Marca", field: "marca", sortable: true },
    // { name: "Familia", field: "familia", sortable: true },
    { name: "Linea", field: "linea", sortable: true },
    { name: "A la Mano", field: "inventario", sortable: true },
    { name: "Pendiente Recibir", field: "porRecibir", sortable: true },
    { name: "Pendiente Surtir", field: "pedido", sortable: true },
    { name: "Pendiente Traspaso", field: "traspaso", sortable: true },
    // { name: "Disponible", field: "disponible", sortable: true },
    { name: "Disponible", field: "aLaMano", sortable: true },
  ];

  const filtrados = useMemo(() => {
    // Copia: el sort de abajo ordena en su lugar. Si se ordenaba la misma
    // lista, la referencia no cambiaba y la página en pantalla no se
    // recalculaba (el orden por columna "no hacía nada").
    let computedComments = [...filasAlmacen];

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.nombre.toLowerCase().includes(search.toLowerCase()) ||
          comment.marca.toLowerCase().includes(search.toLowerCase()) ||
          // comment.familia.toLowerCase().includes(search.toLowerCase()) ||
          comment.linea.toLowerCase().includes(search.toLowerCase()) ||
          comment.inventario.toString().includes(search) ||
          comment.pedido.toString().includes(search) ||
          comment.traspaso.toString().includes(search) ||
          // comment.disponible.toString().includes(search) ||
          comment.aLaMano.toString().includes(search)
      );
    }

    if (activo) {
      computedComments = computedComments.filter((e) =>
        e.activo.includes(activo),
      );
    }

    if (selectedArticulo) {
      computedComments = computedComments.filter((e) =>
        e.idArticulo.includes(selectedArticulo),
      );
    }

    if (selectedMarca) {
      computedComments = computedComments.filter((e) =>
        e.idMarca.includes(selectedMarca),
      );
    }

    if (selectedLinea) {
      computedComments = computedComments.filter((e) =>
        e.idLinea.includes(selectedLinea),
      );
    }

    // if (selectedFamilia) {
    //   computedComments = computedComments.filter((e) =>
    //     e.idFamilia.includes(selectedFamilia)
    //   );
    // }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "inventario" &&
      sorting.field != "porRecibir" &&
      sorting.field != "pedido" &&
      sorting.field != "traspaso" &&
      // sorting.field != "disponible" &&
      sorting.field != "aLaMano"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field]),
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "inventario" ||
        sorting.field == "porRecibir" ||
        sorting.field == "pedido" ||
        sorting.field == "traspaso" ||
        // sorting.field == "disponible" ||
        sorting.field == "aLaMano")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1,
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "inventario" ||
        sorting.field == "porRecibir" ||
        sorting.field == "pedido" ||
        sorting.field == "traspaso" ||
        // sorting.field == "disponible" ||
        sorting.field == "aLaMano")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1,
      );
    }

    return computedComments;
  }, [
    filasAlmacen,
    search,
    sorting,
    selectedArticulo,
    activo,
    // selectedFamilia,
    selectedLinea,
    selectedMarca,
  ]);

  //Current Page slice
  const commentsData = useMemo(
    () =>
      filtrados.slice(
        (currentPage - 1) * ITEMS_PER_PAGE,
        (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
      ),
    [filtrados, currentPage]
  );

  // Totales de TODO lo filtrado (antes sumaba sólo la página en pantalla)
  const totales = useMemo(
    () =>
      filtrados.reduce(
        (t, a) => ({
          inventario: t.inventario + (Number(a.inventario) || 0),
          porRecibir: t.porRecibir + (Number(a.porRecibir) || 0),
          pedido: t.pedido + (Number(a.pedido) || 0),
          traspaso: t.traspaso + (Number(a.traspaso) || 0),
          aLaMano: t.aLaMano + (Number(a.aLaMano) || 0),
        }),
        { inventario: 0, porRecibir: 0, pedido: 0, traspaso: 0, aLaMano: 0 }
      ),
    [filtrados]
  );

  function jalaFoto(idEdit) {
    setPhoto("");
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_GETMEDIA}/${idEdit}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        if (data.data.version) {
          setPhoto(data.data.version);
        }
      })
      .catch((err) => console.log(err));

    setIdEditArticulo(idEdit);
    toggleFoto();
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_disponible ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              <Button
                size="sm"
                href="/MenuInventarios"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Disponible</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>

          <h3 align="center">Disponible{nombreAlmacen ? ` · ${nombreAlmacen}` : ""}</h3>
          <Row className="mb-2">
            <Col md={3}>
              <Label className="mr-sm-2">Almacén</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedAlmacen}
                onChange={(e) => {
                  setSelectedAlmacen(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Todos los almacenes</option>
                {almacenes.map((a) => (
                  <option key={a.id} value={a.id}>
                    {a.nombre}
                  </option>
                ))}
              </Input>
            </Col>
            <Col md={9} style={{ fontSize: 12, color: "#666", alignSelf: "flex-end" }}>
              {selectedAlmacen
                ? String(selectedAlmacen) === String(almacenSurtido.id)
                  ? `De ${nombreAlmacen} se surten los pedidos: su disponible es lo que tiene menos lo pendiente de surtir.`
                  : `De ${nombreAlmacen} no se surten pedidos: su disponible es todo lo que tiene. Lo pendiente de surtir se descuenta de ${almacenSurtido.nombre || "el almacén de surtido"}.`
                : ""}
              {selectedAlmacen ? " \"Pendiente Recibir\" es de todos los almacenes." : ""}
            </Col>
          </Row>
          <div className="row">
            <div className="col-md-10">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-1 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tr>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedArticulo}
                  onChange={(e) => {
                    setSelectedArticulo(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {articulos
                    .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                    .map((a) => {
                      return <option value={a.idArticulo}>{a.nombre}</option>;
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedMarca}
                  onChange={(e) => {
                    setSelectedMarca(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {marcas
                    .sort((a, b) => (a.marca > b.marca ? 1 : -1))
                    .map((a) => {
                      return <option value={a.idMarca}>{a.marca}</option>;
                    })}
                </Input>
              </td> 
              {/* <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedFamilia}
                  onChange={(e) => {
                    setSelectedFamilia(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {familias
                    .sort((a, b) => (a.familia > b.familia ? 1 : -1))
                    .map((a) => {
                      return <option value={a.idFamilia}>{a.familia}</option>;
                    })}
                </Input>
              </td>  */}
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedLinea}
                  onChange={(e) => {
                    setSelectedLinea(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {lineas
                    .sort((a, b) => (a.linea > b.linea ? 1 : -1))
                    .map((a) => {
                      return <option value={a.idLinea}>{a.linea}</option>;
                    })}
                </Input>
              </td>
            </tr>
            <tbody>
              {commentsData.map((a) => {
                // totalDisponible = totalDisponible + a.disponible;
                // totalALaMano = totalALaMano + a.aLaMano;
                {
                  return (
                    <tr>
                      <td>{a.nombre}</td>
                      <td>{a.marca}</td>
                      {/* <td>{a.familia}</td> */}
                      <td>{a.linea}</td>
                      <td> {new Intl.NumberFormat("en-US").format(a.inventario)} </td>
                      <td>{new Intl.NumberFormat("en-US").format(a.porRecibir)}</td>
                      <td>{new Intl.NumberFormat("en-US").format(a.pedido)}</td>
                      <td>{new Intl.NumberFormat("en-US").format(a.traspaso)}</td>
                      {/* <td>
                        {new Intl.NumberFormat("en-US").format(a.disponible)}
                      </td> */}
                      <td>
                        {new Intl.NumberFormat("en-US").format(a.aLaMano)}
                      </td>
                      <td>
                        <Button
                          color="info"
                          id="Editar"
                          size="sm"
                          onClick={(e) => jalaFoto(a.idArticulo)}
                        >
                          <i class="fas fa-camera"></i>
                        </Button>
                      </td>
                    </tr>
                  );
                }
              })}
              <tr>
                <td></td>
                <td></td>
                {/* <td></td> */}
                {/* <td></td> */}
                <td className="negrita">TOTAL</td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US").format(totales.inventario)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US").format(totales.porRecibir)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US").format(totales.pedido)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US").format(totales.traspaso)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US").format(totales.aLaMano)}
                </td>
                {/* <td className="negrita">
                  {new Intl.NumberFormat("en-US").format(totalDisponible)}
                </td> */}
                {/* <td className="negrita">
                  {new Intl.NumberFormat("en-US").format(totalAlaMano)}
                </td> */}
                <td></td>
              </tr>
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <Modal size="sm" isOpen={modalFoto} toggle={toggleFoto}>
        <ModalHeader toggle={toggleFoto}>
          <h4>Ficha Tecnica</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            {photo ? (
              <h6 style={{ textAlign: "center" }}>
                <img
                  // loading="lazy"
                  src={`${process.env.REACT_APP_URL_FOTO_CLOUDINARY}/image/upload/v${photo}/macuroArticulos/${idEditArticulo}.jpg`}
                  alt=""
                />
              </h6>
            ) : (
              <h4>No se ha subido una Ficha Tecnica....</h4>
            )}
          </Row>
        </ModalBody>
      </Modal>

      {loader}
    </>
  );
}

export default ListadoDisponible;
